import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { MisRutas } from './routers/MiRutas';



const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <MisRutas/>
);
